module.exports = __webpack_public_path__ + "img/no_data.90ec57d5.png";